import service from "@/store/services/cash-register-reading-payment-items-service";

export const state = () => ({
  list: {},
  cashRegisterReadingPaymentItem: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, cashRegisterReadingPaymentItem) => {
    state.cashRegisterReadingPaymentItem = cashRegisterReadingPaymentItem;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((cashRegisterReadingPaymentItem) => {
      commit("SET_RESOURCE", cashRegisterReadingPaymentItem);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((cashRegisterReadingPaymentItem) => {
      commit("SET_RESOURCE", cashRegisterReadingPaymentItem);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((cashRegisterReadingPaymentItem) => {
      commit("SET_RESOURCE", cashRegisterReadingPaymentItem);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  cashRegisterReadingPaymentItem: (state) => state.cashRegisterReadingPaymentItem,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((cashRegisterReadingPaymentItem) => ({
      id: cashRegisterReadingPaymentItem.id,
      name: ``,
    }));
  },
};

const cashRegisterReadingPaymentItems = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default cashRegisterReadingPaymentItems;
